import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { SessionService } from '@services/session.service';
import { FormComponent } from '@shared/components';

@Component({
  selector: 'app-campaign-wrapper',
  imports: [RouterOutlet],
  templateUrl: './campaign-wrapper.component.html',
  styleUrl: './campaign-wrapper.component.scss',
})
export class CampaignWrapperComponent extends FormComponent {
  session = inject(SessionService);
  route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      if (params.get('id')) {
        this.loadEndpoint = `admin/campaigns/${params.get('id')}`;
        this.load();
      }
    });
  }

  override onLoadSuccess(response: any): void {
    if (response.data) {
      this.session.campaign = response.data;
    }

    this.stopLoading();
  }
}
